// src/utils/i18nTemplate.js
//
// Tiny shared helper for translated strings that need to embed dynamic
// values (a count, a name, a timestamp) — e.g. common.pagination_summary =
// "Displaying {count} of {total} results". A plain string substitution
// would lose any JSX styling on those values (Pagination.jsx highlights the
// numbers in the theme color) and would also hardcode English word order
// into every caller. renderTemplate splits the translated template on its
// own {placeholder} tokens and lets each caller supply either plain text or
// JSX for each one, so a translator is free to reorder the sentence for
// their own language without any frontend code change.
import React from "react";

export function renderTemplate(template, vars) {
  const parts = String(template ?? "").split(/(\{[a-zA-Z_]+\})/g);
  return parts.map((part, i) => {
    const match = part.match(/^\{([a-zA-Z_]+)\}$/);
    if (match && match[1] in vars) {
      return <React.Fragment key={i}>{vars[match[1]]}</React.Fragment>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}
